import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import * as PageNotifications from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/railways/router/routes';
import { PageContent } from 'app/ui';

import { PersonDetails } from './person-details';

export const DetailsPersonFormPage = observer(() => {
  const { passengerId } = useTypedParams(appRoute.PERSON.DETAILS);

  return (
    <PageNotifications.Provider>
      <PageNotifications.Render>
        {(notifications) => <PageContent>{notifications}</PageContent>}
      </PageNotifications.Render>

      <PageContent>
        <PersonDetails id={passengerId} />
      </PageContent>
    </PageNotifications.Provider>
  );
});
